import {SymbolPositionData} from "../../core/reel/ReelInterfaces";
import {LonerScatterSymbol} from "../reels/symbols/main/LonerScatterSymbol";
import {Loner} from "../Loner";
import {LonerGameMode} from "../server/LonerGameMode";
import {SCATTER_TRANSFORM_TEXTURES} from "../LonerGameAssets";

/**
 * Created by Jerker Nord on 2023-01-19.
 */

export class LonerPoolScatterSymbols {

    private _scatterSymbols:LonerScatterSymbol[];

    public init():void {
        this._scatterSymbols = [];
        for(let i:number = 0; i < 3; i++) {
            this._scatterSymbols.push(this.createScatter());
        }
    }

    private createScatter():LonerScatterSymbol {
        return new LonerScatterSymbol();
    }

    public getSymbol(symbolName:string, symbolPositionData:SymbolPositionData):LonerScatterSymbol {
        for(let i:number = 0; i < this._scatterSymbols.length; i++) {
            if(this._scatterSymbols[i].isUsed == false) {
                this._scatterSymbols[i].isUsed = true;
                this._scatterSymbols[i].symbolName = symbolName;
                this._scatterSymbols[i].stackedSymbolName = symbolName;
                this._scatterSymbols[i].reelPosition = symbolPositionData.position;
                this._scatterSymbols[i].reelId = symbolPositionData.reelID;
                if (Loner.model.data.mode == LonerGameMode.FEATURE_TICK_TICK_BOOM || (Loner.model.data.mode == LonerGameMode.NORMAL && Loner.model.data.nextMode == LonerGameMode.FEATURE_TICK_TICK_BOOM
                    || (Loner.model.data.mode == LonerGameMode.FEATURE_TICK_TICK_BOOM && Loner.model.data.nextMode == LonerGameMode.NORMAL))) {
                    if (symbolPositionData.reelID == 0) {
                        this._scatterSymbols[i].featureTextureName = SCATTER_TRANSFORM_TEXTURES.tick;
                    } else if (symbolPositionData.reelID == 2) {
                        this._scatterSymbols[i].featureTextureName = SCATTER_TRANSFORM_TEXTURES.tickTick;
                    } else {
                        this._scatterSymbols[i].featureTextureName = SCATTER_TRANSFORM_TEXTURES.boom;
                    }
                }
                if (Loner.model.data.mode == LonerGameMode.FEATURE_PIN_THE_WIN || (Loner.model.data.mode == LonerGameMode.NORMAL && Loner.model.data.nextMode == LonerGameMode.FEATURE_PIN_THE_WIN)) {
                    if (symbolPositionData.reelID == 0) {
                        this._scatterSymbols[i].featureTextureName = SCATTER_TRANSFORM_TEXTURES.pin;
                    } else if (symbolPositionData.reelID == 2) {
                        this._scatterSymbols[i].featureTextureName = SCATTER_TRANSFORM_TEXTURES.the;
                    } else {
                        this._scatterSymbols[i].featureTextureName = SCATTER_TRANSFORM_TEXTURES.win;
                    }
                }
                if (Loner.model.data.mode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK || (Loner.model.data.mode == LonerGameMode.NORMAL && Loner.model.data.nextMode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK)) {
                    if (symbolPositionData.reelID == 0) {
                        this._scatterSymbols[i].featureTextureName = SCATTER_TRANSFORM_TEXTURES.shoot;
                    } else if (symbolPositionData.reelID == 2) {
                        this._scatterSymbols[i].featureTextureName = SCATTER_TRANSFORM_TEXTURES.shootShoot;
                    } else {
                        this._scatterSymbols[i].featureTextureName = SCATTER_TRANSFORM_TEXTURES.duck;
                    }
                }

                //Special case for init reels
                if (Loner.model.initData && !Loner.model.gameData && Loner.model.isRestore == false){
                    if (symbolPositionData.reelID == 0){
                        this._scatterSymbols[i].featureTextureName = SCATTER_TRANSFORM_TEXTURES.infectious;
                    }else{
                        this._scatterSymbols[i].featureTextureName = SCATTER_TRANSFORM_TEXTURES.xSplit;
                    }
                }

                return this._scatterSymbols[i];
            }
        }
        this._scatterSymbols.push(this.createScatter());
        return this.getSymbol(symbolName, symbolPositionData);
    }

    public getScatterSymbolOnReel(reelId:number):LonerScatterSymbol {
        for(let i:number = 0; i < this._scatterSymbols.length; i++) {
            if(this._scatterSymbols[i].isUsed == true && this._scatterSymbols[i].reelId == reelId) {
                return this._scatterSymbols[i];
            }
        }
        throw new Error("LonerPoolScatterSymbols: No Scatter on reel: " + reelId);
    }

    public getAllUsedSymbols():LonerScatterSymbol[] {
        const activeSyms:LonerScatterSymbol[] = [];
        for(let i:number = 0; i < this._scatterSymbols.length; i++) {
            if(this._scatterSymbols[i].isUsed == true) {
                activeSyms.push(this._scatterSymbols[i]);
            }
        }
        return activeSyms;
    }
}